<template>
  <div>
    <div>
      <el-card class="btn-card">
        <h2>Inventory:<span>{{totalNumbers}}</span></h2>
        <el-button type="primary" @click='jump(0)'>Outbound shipping</el-button>
        <el-button class="btn-send" @click='jump(1)'>Shipment records</el-button>
      </el-card>
      <div class="table-box">
        <el-table
        v-loading="loading"
        :data="tableData"
        :header-cell-style="{ 'text-align': 'center', color: '#000000', background: '#FAFAFA' }"
        :cell-style="{ 'text-align': 'center' }"
        stripe
        >
        <el-table-column
            prop="upgradeCardType"
            label="TCP types"
        >
        </el-table-column>
        <el-table-column
            prop="currentStorage"
            label="Inventory"
        >
        </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getList
} from '@/api/virtual-card.js'

export default {
  data () {
    return {
      loading: false,
      tableData: [],
      routeList: [
        '/layout/virtual-card/card-send',
        '/layout/virtual-card/card-log'
      ]
    }
  },
  computed: {
    totalNumbers () {
      let total = 0
      this.tableData.forEach(item => {
        total += item.currentStorage
      })
      return total
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 跳转
    jump (index) {
      const path = this.routeList[index]
      this.$router.push(path)
    },
    // 获取列表
    getList () {
      this.loading = true
      getList().then(res => {
        this.tableData = res.data
      })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-card {
  margin-bottom: 20px;
  text-align: center;
  position: relative;
  h2{
      text-align: center;
      span{
          color: #409eff;
      }
  }
  .btn-send{
      position: absolute;
      right: 20px;
      top: 20px;
  }
}
</style>
